module.exports = __webpack_public_path__ + "static/media/Document2.43cdbfd9.svg";